import * as translations from './translations.json';
import i18next from 'i18next';

const english = 'en-US';
let options = {
  lng: english,
  debug: (process.env.NODE_ENV === 'production') ? false: true,
  resources: translations,
  fallbackLng: english,
  interpolation: {
    escapeValue: false
  }
};

class i18nextService {

  init(){
    i18next.init(options);
  }

  t = (key, locale) => {
      options.lng = locale;
      
      let trans = i18next.t(key, options);
      return trans;
  }
}
    
export default new i18nextService();